export default "__VITE_ASSET__BZnRHnlA__"